import { createSlice } from "@reduxjs/toolkit";

const storeAuthenticateSlice = createSlice({
  name: "userDetails",
  initialState: {
    userDetails: null,
  },
  reducers: {
    storeAuthUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
  },
});

export const { storeAuthUserDetails } = storeAuthenticateSlice.actions;
export default storeAuthenticateSlice.reducer;
